import isString from "lodash/isString";
export var sortWithLocale = function (language) {
  return function (a, b) {
    return isString(a) && isString(b) ? new Intl.Collator(language).compare(a, b) : a > b ? 1 : a < b ? -1 : 0;
  };
};